'use strict'
Object.defineProperty(exports, '__esModule', { value: true })
exports.queryStringFromObject = void 0
exports.queryStringFromObject = function (obj) {
  if (!obj || Object.keys(obj).length === 0) return null
  var qs =
    '?' +
    Object.keys(obj)
      .filter(function (key) {
        return obj[key] !== null && obj[key] !== undefined
      })
      .filter(function (key) {
        return (
          typeof obj[key] === 'string' ||
          typeof obj[key] === 'number' ||
          typeof obj[key] === 'boolean'
        )
      })
      .map(function (key) {
        return key + '=' + obj[key]
      })
      .join('&')
  return qs === '?' ? null : qs
}
//# sourceMappingURL=queryStringFromObject.js.map
